import React from 'react';
import { useProduct } from '@montana/containers/product';
import { staticSettings } from '@montana/helpers/static-settings.helper';
import { useSiteStructure } from '@montana/containers/site-structure';

export const JsonLD = () => {

    const {
        productTitleH1,
        productDescriptionLong,
        code,
        prices,
        config,
        cylindoImageUrl,
    } = useProduct();

    const { footer } = useSiteStructure();
    const material = [prices?.materialOne, prices?.materialTwo, prices?.materialThree];

    return (
        <>
            {!!code && (
                <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(
                    {
                        "@context": "http://schema.org",
                        "@type": "Product",
                        "productID": code,
                        "name": productTitleH1,
                        "brand": "Montana Furnitures",
                        "category": "Product",
                        "description": productDescriptionLong,
                        "image": cylindoImageUrl,
                        "sku": prices?.codes?.length ? (prices.codes.length > 1 ? "" : prices.codes[0].variantCode) : "",
                        "material": material.join(', '),
                        ...(prices?.priceWithDiscount?.formatted ? {
                            "offers": {
                                "@type": "Offer",
                                "availability": "InStock",
                                "price": prices?.priceWithDiscount?.formatted,
                                "priceCurrency": prices?.priceWithDiscount?.currency,
                                "url": `${config?.queryString}`
                            }
                        } : {}),
                        "url": `${config?.queryString}`
                    }
                )}}>
                </script>
            )}
            <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(
                {
                    "@context": "http://schema.org/",
                    "@type": "Organization",
                    "name": footer?.companyName,
                    "logo": `${staticSettings.spaUrl}/assets/icons/${'logo.svg'}`,
                    "url": staticSettings.spaUrl,
                    "location": {
                        "address": {
                            "streetAddress": footer?.address,
                            "addressCountry": footer?.country,
                            "postalCode": footer?.zipCode,
                        },
                    },
                    "contactPoint": [
                        {
                            "@type": "ContactPoint",
                            "telephone": footer?.phone,
                            "email": footer?.email,
                            "contactType": "customer service"
                        }
                    ],
                    "email": footer?.email,
                    "telephone": footer?.phone,
                    "taxID": footer?.cvr,
                    ...(footer?.socialColumnLinks?.length ? {
                        "sameAs": footer?.socialColumnLinks?.map(link => link.url)
                    } : {}),
                }
            )}}>
            </script>
        </>
    );
}
